import React from "react";
import DateRangePicker from "../../global-components/litePicker";
import SelectAirbasesDropdown from "../../global-components/selectAirbasesDropdown";
import calendarIcon from "../../../assets/icons/new_icon/calendar.svg";
import SelectLMSLocationDropdown from "../../global-components/selectLMSLocationDropdown";

interface Props {
  origin: any;
  setOrigin: any;
  selectedDates: any;
  setSelectedDates: any;
  site: any;
  setSite: any;
  priority: any;
  setpriority: any;
  handleToggleChange: any;
  setHandleToggleChange: any;
  handleFilter: any;
  priorityList: any;
  postingDate: any;
  setPostingDate: any;
  barCodeNo: string;
  setBarCodeNo: any;
}
function FilterNavLmsLineItems({
  origin,
  setOrigin,
  selectedDates,
  setSelectedDates,
  site,
  setSite,
  priority,
  setpriority,
  handleToggleChange,
  setHandleToggleChange,
  handleFilter,
  priorityList,
  postingDate,
  setPostingDate,
  barCodeNo,
  setBarCodeNo,
}: Props) {
  const handleDateChange = (startDate: Date, endDate: Date) => {
    setHandleToggleChange(true);
    setSelectedDates({ startDate, endDate });
  };

  return (
    <>
      <div className="w-100 mb-4 d-flex gap-3">
        <div className="w-100">
          <label className="dropdown-label" id={"Issue Date"}>
            Order Date
          </label>
          <DateRangePicker
            id={"order_range_picker"}
            className={"form-control ubbe-input date-range-picker"}
            selectedDates={selectedDates}
            onChange={handleDateChange}
            calendarIcon={calendarIcon}
            placeholder="Select date"
          />
        </div>
        <div className="w-100">
          <label className="dropdown-label" id={"Issue Date"}>
            Posting Date
          </label>
          <DateRangePicker
            id={"posting_range_picker"}
            className={"form-control ubbe-input date-range-picker"}
            selectedDates={postingDate}
            onChange={(startDate: Date, endDate: Date) => {
              setHandleToggleChange(true);
              setPostingDate({ startDate, endDate });
            }}
            calendarIcon={calendarIcon}
            placeholder="Select date"
          />
        </div>

        <div className="w-75">
          <SelectLMSLocationDropdown
            selectedLocation={origin}
            setSelectedLocation={setOrigin}
            label={"Origin"}
            setHandleToggleChange={setHandleToggleChange}
          />
        </div>
        <div className="w-75">
          <SelectLMSLocationDropdown
            selectedLocation={site}
            setSelectedLocation={setSite}
            label={"Site"}
            setHandleToggleChange={setHandleToggleChange}
          />
        </div>
        <div className="w-75">
          <SelectAirbasesDropdown
            id="id"
            selectedAirBase={priority}
            setSelectedAirBase={setpriority}
            label={"Priority"}
            setHandleToggleChange={setHandleToggleChange}
            airbaseList={priorityList}
          />
        </div>
        <div className="w-50">
          <div className="form-group">
            <label htmlFor="manifestNo" className="dropdown-label">
              Barcode
            </label>
            <input
              type="text"
              id="manifestNo"
              placeholder="Ex: XXXXXX"
              value={barCodeNo}
              onChange={(e) => {
                setBarCodeNo(e.target.value);

                setHandleToggleChange(true);
              }}
              className="form-control"
              style={{ height: "48px" }}
              maxLength={10}
            />
          </div>
        </div>

        <div className="d-flex flex-column">
          <button
            type="button"
            style={{ width: "132px" }}
            className={
              handleToggleChange
                ? "active-filter mt-auto "
                : "mt-auto  disable-filter"
            }
            onClick={() => {
              handleToggleChange && handleFilter();
            }}
          >
            Filter
          </button>
        </div>
      </div>
    </>
  );
}

export default FilterNavLmsLineItems;
